import { t } from '@hefe/i18n';
import { Gym } from '@hefe/models';
import { GymsSlice, ModalsSlice } from '@hefe/store';
import { Space, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomTable from '../../../core/components/table/custom-table.component';
import AddEditGymForm from '../../forms/add-edit-gym/add-edit-gym.form';

export default function GymsComponent() {
  const dispatch = useAppDispatch();
  const gyms = useSelector(GymsSlice.gymsSelector);

  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    fetchGyms();
  }, []);

  const fetchGyms = () => {
    setLoading(true);
    dispatch(GymsSlice.fetchGyms({ cacheDuration: 5 * 60 * 1000 }))
      .unwrap()
      .catch(() => null)
      .finally(() => setLoading(false));
  };

  const deleteGym = (id: number) => {
    setDeleting(true);
    const gym = gyms.find((g) => g.id === id);
    if (gym) {
      dispatch(GymsSlice.deleteGym(gym))
        .unwrap()
        .catch(() => null)
        .finally(() => setDeleting(false));
    }
  };

  const openEditGymModal = (gym: Gym) => {
    dispatch(
      ModalsSlice.modalsActions.openModal({
        component: <AddEditGymForm gym={gym} />,
        title: gym.name,
        formId: `add-edit-gym-form-${gym.id}`,
      })
    );
  };

  return (
    <div>
      <CustomTable
        name="gyms"
        rowKey="id"
        loading={loading}
        dataSource={gyms}
        onRowClick={(gym: Gym) => openEditGymModal(gym)}
        columns={[
          {
            key: 'name',
            title: t('name'),
            dataIndex: 'name',
            showFilter: true,
            default: true,
          },
          {
            key: 'address',
            title: t('address'),
            default: true,
            render: (gym: Gym) => {
              return (
                <Space direction="vertical">
                  <Typography.Text>{gym.street}</Typography.Text>
                  <Typography.Text>
                    {gym.zipcode} {gym.city}
                  </Typography.Text>
                </Space>
              );
            },
          },
          {
            key: 'parking',
            title: t('parking'),
            dataIndex: 'parking',
            default: false,
          },
          {
            key: 'max_spectators',
            title: t('max_spectators'),
            dataIndex: 'max_spectators',
            default: false,
          },
        ]}
        addForm={{
          title: t('add_gym'),
          formId: 'add-edit-gym-form-new',
          component: <AddEditGymForm key={gyms.length} />,
        }}
        deleteAction={{
          action: (keys: any[]) => (keys[0] ? deleteGym(keys[0]) : null),
          loading: deleting,
        }}
      />
    </div>
  );
}
